import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/HomeView.vue'
import Empresa from '../views/EmpresaView.vue'
import Manutencao from '../views/ManutencaoView.vue'
import Solucoes from '../views/SolucoesView.vue'
import SolucaoTecnica from '../views/SolucaoTecnicaView.vue'
import Orcamento from '../views/OrcamentoView.vue'
import Blog from '../views/BlogView.vue'
import BlogDetalhe from '../views/BlogDetalheView.vue'
import Contato from '../views/ContatoView.vue'
import Informacoes from '../views/InformacoesView.vue'


const routes = [
 { path: '/', name: 'Home', component: Home },
 { path: '/empresa', name: 'Empresa', component: Empresa },
 { path: '/manutencao', name: 'Manutencao', component: Manutencao },
 { path: '/solucoes', name: 'Solucoes', component: Solucoes },
 { path: '/solucaotecnica/:id/:nome', name: 'SolucaoTecnica', component: SolucaoTecnica },
 { path: '/orcamento', name: 'Orcamento', component: Orcamento },
 { path: '/blog', name: 'Blog', component: Blog },
 { path: '/blogdetalhe/:id/:nome', name: 'BlogDetalhe', component: BlogDetalhe },
 { path: '/contato', name: 'Contato', component: Contato },
 { path: '/informacoes/:id/:nome', name: 'Informacoes', component: Informacoes },
 
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
  next()
})

export default router